import { render, staticRenderFns } from "./SchemaInputModal.vue?vue&type=template&id=6642452d&scoped=true&"
import script from "./SchemaInputModal.vue?vue&type=script&lang=js&"
export * from "./SchemaInputModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6642452d",
  null
  
)

export default component.exports